var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 623",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.60606 .25223)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 623,
    "data-background-color": "#ffffff",
    viewBox: "0 0 396 247",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.24 -.1)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 247.2,
    viewBox: "0 0 395.52 247.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 247.2,
    viewBox: "0 0 395.52 247.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.552 55.862)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    viewBox: "0 0 316.416 135.47537870855146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    viewBox: "0 0 316.416 135.47537870855146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    viewBox: "0 0 316.416 135.47537870855146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    viewBox: "0 0 316.416 135.47537870855146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    viewBox: "0 0 316.416 135.47537870855146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    viewBox: "0 0 316.416 135.47537870855146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 316.42,
    height: 135.48,
    "data-palette-color": "#000000",
    viewBox: "1.9500000476837158 -36.099998474121094 85.95000457763672 36.79999923706055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "undefined-text-0",
    d: "m15.6-35.4v1q-1.65 0.05-2.5 0.38-0.85 0.32-1.15 1.19-0.3 0.88-0.3 2.73v24.8q0 1.8 0.3 2.7t1.15 1.2 2.5 0.4v1q-1.2-0.1-3.02-0.13-1.83-0.02-3.73-0.02-2.1 0-3.92 0.02-1.83 0.03-2.98 0.13v-1q1.7-0.1 2.55-0.4t1.13-1.2q0.27-0.9 0.27-2.7v-24.8q0-1.85-0.27-2.73-0.28-0.87-1.15-1.19-0.88-0.33-2.53-0.38v-1q1.15 0.05 2.98 0.1 1.82 0.05 3.92 0.05 1.9 0 3.73-0.05 1.82-0.05 3.02-0.1zm17.7 0.15q1.9 0 3.12 0.37 1.23 0.38 2.08 0.98 1.05 0.75 1.65 1.7t0.6 1.95q0 1.35-0.98 2.12-0.97 0.78-2.17 0.78t-2.08-0.7q-0.87-0.7-0.87-2 0-1.15 0.8-2.03 0.8-0.87 2-1.02-0.25-0.55-1.23-0.95-0.97-0.4-2.37-0.4-2.6 0-4.28 1.55-1.67 1.55-1.67 4.6 0 1.3 0.47 2.7 0.48 1.4 1.88 2.8 0.85-0.15 1.67-0.25 0.83-0.1 1.33-0.1 1.95 0 1.95 1.25 0 0.45-0.4 0.7t-1 0.25q-0.95 0-1.95-0.43-1-0.42-1.55-0.72-2.75 0.95-4.43 2.87-1.67 1.93-1.67 5.28 0 3.4 1.8 5.73 1.8 2.32 4.9 3.52t7.1 1.2q2.6 0 5-0.6t4.27-1.78q1.88-1.17 2.98-2.82t1.1-3.8q0-0.9-0.35-2.3t-1.48-2.75q-1.12-1.35-3.47-2.15l0.5-0.5q3.35 1.05 4.85 3.45t1.5 5.4q0 3.15-1.93 5.92-1.92 2.78-5.47 4.45-3.55 1.68-8.55 1.68-4.7 0-8.55-1.5t-6.1-4.3-2.25-6.65q0-2.75 1.07-4.68 1.08-1.92 2.68-3.2 1.6-1.27 3.2-1.95 1.6-0.67 2.6-0.92-2.45-1.05-3.85-2.73-1.4-1.67-1.4-3.67 0-1.35 0.65-2.5t1.82-2.03q1.18-0.87 2.8-1.34 1.63-0.48 3.68-0.48zm18.65-0.85q3.25 0 5.4 1.8t2.15 5.05q0 3-1.83 4.82-1.82 1.83-4.72 2.83-1 0.45-2.6 0.97-1.6 0.53-3.4 1.08t-3.43 1.05q-1.62 0.5-2.67 0.9-2.5 0.75-4.05 1.77-1.55 1.03-1.55 2.73 0 1.3 0.77 2.2 0.78 0.9 1.9 1.35 1.13 0.45 2.18 0.45 0.65 0 1.57-0.23 0.93-0.22 1.08-0.67-0.95-0.2-1.68-0.88-0.72-0.67-0.72-1.92 0-1.3 0.92-2.05 0.93-0.75 2.28-0.75 1.4 0 2.22 0.8 0.83 0.8 0.83 2.1 0 1.45-0.95 2.45t-2.4 1.47q-1.45 0.48-3 0.48-1.6 0-3.13-0.63-1.52-0.62-2.5-1.95-0.97-1.32-0.97-3.47 0-3 2.15-4.9t6.15-3q1.35-0.45 3.22-0.95 1.88-0.5 3.83-1.08 1.95-0.57 3.6-1.27 2.85-1.1 4.1-2.25t1.25-2.6q0-2.15-1.73-3.53-1.72-1.37-4.02-1.37-0.55 0-0.93 0.07-0.37 0.08-0.52 0.33 0.85 0.35 1.3 1.1t0.45 1.45q0 1.25-0.95 1.97-0.95 0.73-2.25 0.73-1.2 0-2.15-0.7t-0.95-2.05q0-1.3 0.85-2.12 0.85-0.83 2.17-1.21 1.33-0.37 2.73-0.37zm35.95 0.7q-0.2 2-0.28 3.9-0.07 1.9-0.07 2.9 0 1.15 0.04 2.2 0.06 1.05 0.11 1.8h-1.15q-0.46-3.65-1.23-5.73-0.77-2.07-2.32-3-1.55-0.92-4.45-0.92h-2.65q-1.6 0-2.43 0.27-0.82 0.28-1.13 1.1-0.29 0.83-0.29 2.58v24.9q0 1.85 0.4 2.77 0.39 0.93 1.5 1.23 1.1 0.3 3.25 0.35v1.05q-1.36-0.1-3.5-0.13-2.15-0.02-4.45-0.02-2 0-3.83 0.02-1.82 0.03-3.07 0.13v-1q1.7-0.1 2.55-0.4t1.12-1.2q0.28-0.9 0.28-2.7v-24.8q0-1.85-0.28-2.73-0.27-0.87-1.15-1.19-0.87-0.33-2.52-0.38v-1q2.55 0.05 5.47 0.1 2.93 0.05 5.5 0.05 2.58 0 4.13 0 2.3 0 5.22-0.02 2.92-0.03 5.23-0.13zm-17.35 17.5h9.7t0 0.5 0 0.5h-9.7t0-0.5 0-0.5zm9.6-6.6h1.15q-0.21 2.85-0.18 4.35t0.03 2.75 0.05 2.75 0.25 4.35h-1.15q-0.21-1.65-0.6-3.18-0.4-1.52-1.45-2.47t-3.16-0.95v-1q2.11 0 3.11-1.13 1-1.12 1.37-2.67 0.38-1.55 0.58-2.8z",
    "data-fill-palette-color": "primary"
  }))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m0 247.2v-247.2h395.52v247.2zm383.3-12.217v-222.77h-371.09v222.77z",
    fontFamily: "none",
    fontSize: "none",
    fontWeight: "none",
    strokeDasharray: "",
    strokeMiterlimit: 10,
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary",
    xmlns: "http://www.w3.org/2000/svg"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.19ae10a6f2f38d260b1a57048008222f.svg";
export { ForwardRef as ReactComponent };